import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import ModalVideo from 'react-modal-video';
import CountUp from 'react-countup';
import { Styles } from "./styles/aboutUs.js";
import useSiteContent from '../hooks/useSiteContent';

const AboutUs = () => {
    const [isOpen, setIsOpen] = useState(false);
    const about = useSiteContent("about");

    return (
        <Styles>
            {/* About Us */}
            <section className="about-us">
                <Container>
                    <Row>
                        <Col md="6">
                            <div className="about-image">
                                {about.mainImage && <img src={process.env.PUBLIC_URL + `/assets/images/${about.mainImage}`} className="main-img" alt="" />}
                                <img src={process.env.PUBLIC_URL + "/assets/images/pattern.png"} className="pattern-img" alt="" />
                                <div className="video-player" style={{backgroundImage: about.videoBackground ? `url(${process.env.PUBLIC_URL}/assets/images/${about.videoBackground})` : undefined}}>
                                    <ModalVideo channel='youtube' isOpen={isOpen} videoId={about.videoId} onClose={() => setIsOpen(false)} />
                                    <button onClick={() => setIsOpen(true)} className="play-button"><i className="las la-play"></i></button>
                                </div>
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="about-content">
                                <h4 className="about-title">{about.title}</h4>
                                <p className="about-para">{about.desc1}<span>{about.desc2}</span></p>
                                <Row>
                                    {(about.counters || []).map((counter, i) => (
                                        <Col sm="4" key={i}>
                                            <div className={`counter-box box${i + 1} text-center`}>
                                                <h3><CountUp end={counter.value} duration={5} delay={1.5} /><i className="las la-plus"></i></h3>
                                                <p>{counter.label}</p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                                <Link className="readmore-btn" to={process.env.PUBLIC_URL + "/about"}>Read More</Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default AboutUs
